import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Chip,
  Stack,
  Paper,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import StarIcon from "@mui/icons-material/Star";
import CloseIcon from "@mui/icons-material/Close";

function FeaturedTraining() {
  const [hovered, setHovered] = useState(false);
  const [openVideo, setOpenVideo] = useState(false);

  const handleOpenVideo = () => {
    setOpenVideo(true);
  };

  const handleCloseVideo = () => {
    setOpenVideo(false);
  };

  const trainingDemoVideo = "https://www.w3schools.com/html/mov_bbb.mp4";

  return (
    <>
      <Box>
        <Typography
          sx={{
            fontSize: "13px",
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            mb: 1.5,
            color: "#202020",
          }}
        >
          Featured Training
        </Typography>

        <Paper
          elevation={0}
          sx={{
            border: "1px solid #E6E6E6",
            borderRadius: "16px",
            overflow: "hidden",
            backgroundColor: "#FFFFFF",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Box
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
              onClick={handleOpenVideo}
              sx={{
                position: "relative",
                width: { xs: "100%", md: "320px" },
                height: { xs: "220px", md: "auto" },
                minHeight: { md: "280px" },
                background:
                  "linear-gradient(135deg, rgba(57,109,135,0.18), rgba(57,109,135,0.05))",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1.5,
                }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "flex-end", gap: "4px" }}
                >
                  {[10, 16, 24, 14, 28, 18, 12, 22, 16, 26, 14].map((h, i) => (
                    <Box
                      key={i}
                      sx={{
                        width: "4px",
                        height: `${h * 2}px`,
                        backgroundColor: "#396D87",
                        borderRadius: "4px",
                        opacity: 0.35,
                      }}
                    />
                  ))}
                </Box>

                <Typography
                  sx={{
                    fontSize: "11px",
                    fontWeight: 700,
                    color: "#396D87",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                  }}
                >
                  Getting Started
                </Typography>
              </Box>

              <Box
                sx={{
                  position: "relative",
                  zIndex: 1,
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  backgroundColor: "#396D87",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transform: hovered ? "scale(1.08)" : "scale(1)",
                  transition: "transform 0.2s ease",
                  boxShadow: "0px 8px 20px rgba(0,0,0,0.15)",
                }}
              >
                <PlayArrowIcon sx={{ color: "#fff", fontSize: 30 }} />
              </Box>
            </Box>

            <Box sx={{ flex: 1, p: 3 }}>
              <Stack direction="row" spacing={1} sx={{ mb: 1.5 }}>
                <Chip
                  label="Featured"
                  size="small"
                  sx={{
                    backgroundColor: "#FFE7CC",
                    color: "#A14F03",
                    fontWeight: 600,
                  }}
                />
              </Stack>

              <Typography
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  color: "#202020",
                  mb: 1,
                }}
              >
                Getting Started with RepAssist
              </Typography>

              <Typography
                sx={{
                  fontSize: "14px",
                  lineHeight: 1.7,
                  color: "#666666",
                  maxWidth: "800px",
                }}
              >
                A comprehensive walkthrough of RepAssist core features — from
                setting up your profile and territories to running your first
                AI-powered Q&A session and logging HCP interactions.
              </Typography>

              <Stack direction="row" spacing={3} sx={{ mt: 2.5, mb: 3 }}>
                <Stack direction="row" spacing={0.7} alignItems="center">
                  <AccessTimeIcon sx={{ fontSize: 16, color: "#666666" }} />
                  <Typography sx={{ fontSize: "12px", color: "#666666" }}>
                    24 min
                  </Typography>
                </Stack>
              </Stack>

              <Stack direction="row" spacing={1.5}>
                <Button
                  variant="contained"
                  startIcon={<PlayArrowIcon />}
                  onClick={handleOpenVideo}
                  sx={{
                    backgroundColor: "#396D87",
                    textTransform: "none",
                    borderRadius: "10px",
                    px: 2.5,
                    "&:hover": {
                      backgroundColor: "#2f5c72",
                    },
                  }}
                >
                  Watch Now
                </Button>
              </Stack>
            </Box>
          </Box>
        </Paper>
      </Box>

      <Dialog
        open={openVideo}
        onClose={handleCloseVideo}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            overflow: "hidden",
            backgroundColor: "#000",
          },
        }}
      >
        <DialogContent
          sx={{ p: 0, position: "relative", backgroundColor: "#000" }}
        >
          <IconButton
            onClick={handleCloseVideo}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              zIndex: 2,
              backgroundColor: "rgba(255,255,255,0.15)",
              color: "#fff",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.25)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>

          <Box sx={{ width: "100%", backgroundColor: "#000" }}>
            <video
              controls
              autoPlay
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                maxHeight: "80vh",
              }}
            >
              <source src={trainingDemoVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default FeaturedTraining;
